import { loading, error } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import * as types from './types';

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PARTICIPATION_REPORT_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/Participation',
        data
      );
      dispatch({
        type: types.PARTICIPATION_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.PARTICIPATION_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.PARTICIPATION_REPORT_LOADING, false));
  };
};

export const downloadReport = (model, fileName) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PARTICIPATION_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postDownloadFile(
        'Reports/Participation',
        fileName,
        model,
        FileDownloadTypes.ExcelOpenXML
      );
      dispatch({
        payload: response ? response.data : 'No Data',
        type: types.PARTICIPATION_REPORT_GET_REPORT,
      });
    } catch (e) {
      dispatch(error(types.PARTICIPATION_REPORT_ERROR, e));
    }
    dispatch(loading(types.PARTICIPATION_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.PARTICIPATION_REPORT_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/participation/state/report/actions.js